
import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SpotifyTrack } from '@/lib/types';

interface TrackPreviewProps {
  track: SpotifyTrack;
  onClose: () => void;
}

const TrackPreview: React.FC<TrackPreviewProps> = ({ track, onClose }) => {
  return (
    <div className="p-4 rounded-lg border flex items-center space-x-4 animate-fade-in">
      <img 
        src={track.albumCover} 
        alt={track.name}
        className="w-16 h-16 rounded"
      />
      <div>
        <h4 className="font-medium">{track.name}</h4>
        <p className="text-sm text-muted-foreground">{track.artist}</p>
      </div>
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onClose}
        className="ml-auto"
      >
        <X size={16} />
      </Button>
    </div>
  );
};

export default TrackPreview;
